(function () {
  "use strict";

  function initKitchenGuide(root) {
    if (!root || root.dataset.ekgInitialized === "true") {
      return;
    }
    root.dataset.ekgInitialized = "true";

    var pages = Array.prototype.slice.call(
      root.querySelectorAll("[data-ekg-page]")
    );

    if (!pages.length) {
      return;
    }

    var guide = root.querySelector("[data-ekg-guide]");
    var list = root.querySelector("[data-ekg-list]");
    var rail = root.querySelector("[data-ekg-rail]");
    var prevButton = root.querySelector("[data-ekg-prev]");
    var nextButton = root.querySelector("[data-ekg-next]");
    var counter = root.querySelector("[data-ekg-counter]");
    var progress = root.querySelector("[data-ekg-progress]");
    var scrollButton = root.querySelector("[data-ekg-scroll]");

    var total = pages.length;
    var activeIndex = 0;
    var isGuideInView = false;

    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var scrollBehavior = prefersReducedMotion ? "auto" : "smooth";

    /* ---------------------------------------------------------
     * Helpers
     * --------------------------------------------------------- */

    function padNumber(number) {
      return String(number).padStart(2, "0");
    }

    function updateRail() {
      if (counter) {
        counter.textContent =
          padNumber(activeIndex + 1) + " / " + padNumber(total);
      }

      if (progress) {
        var percent = ((activeIndex + 1) / total) * 100;
        progress.style.width = percent + "%";
      }

      if (prevButton) {
        prevButton.disabled = activeIndex === 0;
      }

      if (nextButton) {
        nextButton.disabled = activeIndex === total - 1;
      }
    }

    function setActiveIndex(index) {
      if (index < 0 || index >= total || index === activeIndex) {
        return;
      }
      activeIndex = index;
      updateRail();
    }

    function scrollToIndex(index) {
      if (index < 0 || index >= total) {
        return;
      }

      var target = pages[index];

      if (!target) {
        return;
      }

      var railHeight = rail ? rail.getBoundingClientRect().height : 0;
      var targetTop =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        railHeight -
        16;

      window.scrollTo({
        top: targetTop,
        behavior: scrollBehavior
      });

      target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });

      setActiveIndex(index);
    }

    function goNext() {
      scrollToIndex(activeIndex + 1);
    }

    function goPrevious() {
      scrollToIndex(activeIndex - 1);
    }

    /* ---------------------------------------------------------
     * Buttons
     * --------------------------------------------------------- */

    if (nextButton) {
      nextButton.addEventListener("click", goNext);
    }

    if (prevButton) {
      prevButton.addEventListener("click", goPrevious);
    }

    if (scrollButton) {
      scrollButton.addEventListener("click", function () {
        scrollToIndex(0);
      });
    }

    /* ---------------------------------------------------------
     * Reveal + active-page tracking via IntersectionObserver
     * --------------------------------------------------------- */

    if ("IntersectionObserver" in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "0px 0px -10% 0px", threshold: 0.08 }
      );

      pages.forEach(function (page) {
        revealObserver.observe(page);
      });

      var activeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = pages.indexOf(entry.target);
              if (index !== -1) {
                setActiveIndex(index);
              }
            }
          });
        },
        { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
      );

      pages.forEach(function (page) {
        activeObserver.observe(page);
      });

      if (guide) {
        var guideVisibilityObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              isGuideInView = entry.isIntersecting;
            });
          },
          { threshold: 0.05 }
        );
        guideVisibilityObserver.observe(guide);
      }
    } else {
      pages.forEach(function (page) {
        page.classList.add("is-visible");
      });
    }

    /* ---------------------------------------------------------
     * Keyboard navigation (only while the guide is in view)
     * --------------------------------------------------------- */

    document.addEventListener("keydown", function (event) {
      if (!isGuideInView) {
        return;
      }

      var target = event.target;
      if (
        target &&
        (target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.tagName === "SELECT" ||
          target.isContentEditable)
      ) {
        return;
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        goNext();
      }

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goPrevious();
      }
    });

    /* ---------------------------------------------------------
     * Initial state
     * --------------------------------------------------------- */

    updateRail();

    /* ---------------------------------------------------------
     * Shopify theme editor support
     * --------------------------------------------------------- */

    document.addEventListener("shopify:section:load", function (event) {
      if (
        event.detail &&
        event.detail.sectionId === root.dataset.sectionId
      ) {
        root.dataset.ekgInitialized = "false";
        initKitchenGuide(root);
      }
    });
  }

  function initializeAllGuides() {
    var guides = document.querySelectorAll("[data-ekg]");
    guides.forEach(function (guide) {
      initKitchenGuide(guide);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAllGuides);
  } else {
    initializeAllGuides();
  }
})();